<div
    *ngIf="filter"
    [id]="filter.id + '.' + filter.id"
    class="agpr-statusFilter"
>
    <agpr-scroll-panel>
        @if (!filter.entityType || filter.entityType !== entityType.OUTLET) {
            <!--Hide contact type filter in private contact page and always show contact type filter in list result page-->
            <div
                *ngIf="(searchIncludesPrivateContacts && currentRouteType !== discoverRouteTypes.privateContacts) || currentRouteType === discoverRouteTypes.targetingListSearchResult"
                class="agpr-statusFilter-contactType"
            >
                <label>{{ 'Discover.targeting.searchFieldLabels.include' | localize }}</label>
                <agpr-checkbox
                    id="statusFilter_includeSystemContacts_checkbox"
                    [binary]="true"
                    label="Discover.targeting.filter.contactType.system"
                    [(ngModel)]="value.includeSystemContacts"
                    (ngModelChange)="handleChange()"
                ></agpr-checkbox>
                <agpr-checkbox
                    id="statusFilter_includePrivateContacts_checkbox"
                    [binary]="true"
                    label="Discover.targeting.filter.contactType.private"
                    [(ngModel)]="value.includePrivateContacts"
                    (ngModelChange)="handleChange()"
                ></agpr-checkbox>
            </div>

            <agpr-checkbox
                id="statusFilter_newContact_checkbox"
                [binary]="true"
                label="Discover.statusFilter.createdDateLabel"
                infoCircleTooltip="Discover.badges.tooltips.contact.new"
                [(ngModel)]="hasCreatedDate"
                (ngModelChange)="dateFieldChecked(statusFilterType.created)"
            ></agpr-checkbox>
            <div
                *ngIf="hasCreatedDate"
                class="agpr-statusFilter-indented"
            >
                <label id="statusFilter_createdDatePicker_label">{{'Discover.statusFilter.newSinceLabel' | localize}}</label>
                <agpr-date-picker
                    [id]="'statusFilter_createdDate_datePicker'"
                    ariaLabelledBy="statusFilter_createdDatePicker_label"
                    [(ngModel)]="value.createdDate"
                    (blur)="handleChange()"
                    (select)="handleChange()"
                ></agpr-date-picker>
            </div>

            <agpr-checkbox
                id="statusFilter_recentlyUpdated_checkbox"
                [binary]="true"
                label="Discover.statusFilter.updatedDateLabel"
                infoCircleTooltip="Discover.badges.tooltips.contact.recentlyUpdated"
                [(ngModel)]="hasUpdatedDate"
                (ngModelChange)="dateFieldChecked(statusFilterType.updated)"
            ></agpr-checkbox>
            <div
                *ngIf="hasUpdatedDate"
                class="agpr-statusFilter-indented"
            >
                <label id="statusFilter_updatedDatePicker_label">{{'Discover.statusFilter.updatedSinceLabel' | localize}}</label>
                <agpr-date-picker
                    [id]="'statusFilter_updatedDate_datePicker'"
                    ariaLabelledBy="statusFilter_updatedDatePicker_label"
                    [(ngModel)]="value.updatedDate"
                    (blur)="handleChange()"
                    (select)="handleChange()"
                ></agpr-date-picker>
            </div>

            <!-- TODO: Recently Verified - Hidden for now (10-1) -->
            <!-- <agpr-checkbox
                [(ngModel)]="hasVerifiedDate"
                [binary]="true"
                label='Discover.statusFilter.verifiedDateLabel'
                (ngModelChange)="dateFieldChecked(statusFilterType.verified)"
                [tooltip]="'Discover.badges.tooltips.contact.recentlyVerified' | localize"
            ></agpr-checkbox>
            <div
                *ngIf="hasVerifiedDate"
                class="agpr-statusFilter-indented"
            >
                <label id="statusFilter_verifiedSinceDatePicker_label">{{'Discover.statusFilter.verifiedSinceLabel' | localize}}</label>
                <agpr-date-picker
                    [id]="'statusFilter_verifiedSince_datePicker'"
                    ariaLabelledBy="statusFilter_verifiedSinceDatePicker_label"
                    [(ngModel)]="value.verifiedDate"
                    (blur)="handleChange()"
                    (select)="handleChange()"
                ></agpr-date-picker>
            </div> -->

            <agpr-checkbox
                id="statusFilter_newEmployment_checkbox"
                [binary]="true"
                label="Discover.statusFilter.newEmploymentLabel"
                infoCircleTooltip="Discover.badges.tooltips.contact.newEmployment"
                [(ngModel)]="hasNewEmploymentDate"
                (ngModelChange)="dateFieldChecked(statusFilterType.newEmployment)"
            ></agpr-checkbox>
            <div
                *ngIf="hasNewEmploymentDate"
                class="agpr-statusFilter-indented"
            >
                <label id="statusFilter_newEmploymentDatePicker_label">{{'Discover.statusFilter.newEmploymentSinceLabel' | localize}}</label>
                <agpr-date-picker
                    [id]="'statusFilter_newEmployment_datePicker'"
                    ariaLabelledBy="statusFilter_newEmploymentDatePicker_label"
                    [(ngModel)]="value.newEmploymentDate"
                    (blur)="handleChange()"
                    (select)="handleChange()"
                ></agpr-date-picker>
            </div>

            <agpr-checkbox
                id="statusFilter_longstanding_checkbox"
                [binary]="true"
                label="Discover.statusFilter.longstanding"
                infoCircleTooltip="Discover.badges.tooltips.contact.veteran"
                [(ngModel)]="value.isLongstanding"
                (ngModelChange)="handleChange()"
            ></agpr-checkbox>

            <agpr-checkbox
                id="statusFilter_multipleEmployments_checkbox"
                [binary]="true"
                label="Discover.statusFilter.multipleEmployments"
                infoCircleTooltip="Discover.badges.tooltips.contact.multipleEmployments"
                [(ngModel)]="value.hasMultipleEmployments"
                (ngModelChange)="handleChange()"
            ></agpr-checkbox>
            <!-- Active Notices are only applied on Targeting Lists -->
            <agpr-checkbox
                *ngIf="currentRouteType === discoverRouteTypes.targetingListSearchResult"
                id="statusFilter_hasActiveNotices_checkbox"
                [binary]="true"
                label="Discover.statusFilter.activeNoticesLabel"
                infoCircleTooltip="Discover.badges.tooltips.contact.activeNotices"
                [(ngModel)]="value.hasActiveNotices"
                (ngModelChange)="handleChange()"
            ></agpr-checkbox>
        }
        <agpr-checkbox
            id="statusFilter_aiReferenceLeaders_checkbox"
            [binary]="true"
            label="Discover.statusFilter.aiReferenceLeader"
            [infoCircleTooltip]="
                filter.entityType == entityType.CONTACT 
                ? 'Discover.statusFilter.aiReferenceLeader.contact' 
                : filter.entityType == entityType.OUTLET
                ? 'Discover.statusFilter.aiReferenceLeader.outlet'
                : 'Discover.statusFilter.aiReferenceLeader.list'
            "
            [(ngModel)]="value.isAiReference"
            (ngModelChange)="handleChange()"
        ></agpr-checkbox>
    </agpr-scroll-panel>
</div>
